import { API_URL } from './../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    extractDataFromObject,
   API_URL,
};

export const GET_CHECKUSERPASSWORDSTATUS = `${API_URL}/User/CheckUserPasswordStatus`;


export const PatientDashboardActionTypes = {
  get_master_data: createRequestActionTypes('GET_MASTER_DATA'),
  get_CheckUserPasswordStatus: createRequestActionTypes('GET_CHECKUSERPASSWORDSTATUS'), 
 // get_appConfig: createRequestActionTypes('GET_APPCONFIG')  
};




// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/dashboard/constants/ApiConstants.js